import React, { useState, useEffect } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { Grid } from '@material-ui/core';

import Intro from 'on_web/components/onboarding/intro/Intro';
import IntroTerms from 'on_web/components/onboarding/intro/IntroTerms';
import IntroAgreement from 'on_web/components/onboarding/intro/IntroAgreement';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import {
  ROUTE_PATH_SELECTION,
  ROUTE_ONBOARDING_DNA,
  ROUTE_ONBOARDING_GENERAL,
} from 'routes';
import { getRedirectRoute } from '../helpers/redirectHelper';

import useUsersApi from '../hooks/useUsersApi';
import UserProfileContext from 'on_web/context/userProfileContext';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

export default function OnboardingIntro(props) {
  const context = React.useContext(UserProfileContext);
  const [visibleStep, setVisibleStep] = useState(
    props.location.state ? null : 0
  );
  const [{ response, loading, getUserData, saveUserData }] = useUsersApi();

  useEffect(() => {
    getUserData().then(response => {
      if (response != null) {
        if (visibleStep == null && props.location.state.startFromLast) {
          return setVisibleStep(1);
        } else if (Object.keys(response.user_metadata).length === 0) {
          setVisibleStep(0);
        } else if (response.user_metadata.introSeen == null) {
          setVisibleStep(0);
        } else if (response.user_metadata.agreement == null) {
          setVisibleStep(1);
        } else {
          const route = getRedirectRoute(
            response.user_metadata,
            context.showBasicQuestions
          );
          props.history.push(route);
        }
      }
    });
  }, [getUserData]);

  const handleNextClick = userMetaData => {
    response.user_metadata = userMetaData;
    if (visibleStep + 1 > 1) {
      let onboarding = {
        ...response.user_metadata.onboarding,
        introFinished: true,
      };
      response.user_metadata.onboarding = onboarding;
      saveUserData(response).then(resp => {
        if (resp != null) {
          trackEvent(
            'Completed INTRO',
            'User has completed INTRO section onboarding'
          );
          props.history.push({
            pathname:
              process.env.REACT_APP_HIDE_DNA_SECTION !== 'true'
                ? ROUTE_ONBOARDING_DNA
                : ROUTE_ONBOARDING_GENERAL,
            state: { startFromFirst: true },
          });
        }
      });
    } else {
      saveUserData(response).then(resp => {
        if (resp != null) {
          setVisibleStep(visibleStep + 1);
        }
      });
    }
  };

  return (
    <div>
      <Grid
        container={useMediaQuery('(min-width:1000px)')}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {loading === false && response && visibleStep != null && (
          <UserProfileContext.Provider value={response}>
            {visibleStep === 0 && (
              <PageItemContainer>
                <Intro
                  onClickNext={userMetaData => handleNextClick(userMetaData)}
                  onClickBack={() => props.history.push(ROUTE_PATH_SELECTION)}
                />
              </PageItemContainer>
            )}
            {visibleStep === 1 && (
              <PageItemContainer>
                <IntroTerms
                  onClickNext={userMetaData => handleNextClick(userMetaData)}
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                />
              </PageItemContainer>
            )}
            {visibleStep === 2 && (
              <PageItemContainer>
                <IntroAgreement
                  onClickNext={userMetaData => handleNextClick(userMetaData)}
                  onClickBack={() => setVisibleStep(visibleStep - 1)}
                />
              </PageItemContainer>
            )}
          </UserProfileContext.Provider>
        )}
      </Grid>
    </div>
  );
}
